import {visibilityFilter} from '../../utils/VisibilityFilter';
import {RootState} from '../../store';

const key = 'personas';

export const recordsSelector = (state: RootState) => {
    return state[key].records;
};

export const recordSelector = (state: RootState, id: string) => {
    const records = recordsSelector(state);
    const loading = records.loading;
    const record = records.byId[id];
    return {
        record,
        loading,
    };
};

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilitySelector = (state: RootState) => {
    const items = personasSelector(state);
    const page = state[key].visibility.page;
    const limit = state[key].visibility.limit;
    const keyword = state[key].visibility.keyword;
    const visible = state[key].visibility.visible;


    const visibleItems = visibilityFilter(items, page, limit, keyword);

    const totalCount = state[key].records.totalCount;

    let visibleCount = totalCount;
    if (keyword) {
        visibleCount = visibleItems.length;
    }

    const totalPages = Math.ceil(visibleCount / limit);

    return {
        items: items,
        visibleItems: visibleItems,
        page: page,
        limit: limit,
        keyword: keyword,
        visible: visible,
        visibleCount: visibleCount,
        totalPages: totalPages,
    };
};

export const personasSelector = (state: RootState) => {
    const all = state[key].records.ids.map((id: string) => {
        return state[key].records.byId[id];
    });
    return all;
};

export const personaSelector = (state: RootState, id: string) => {
    return state[key].records.byId[id];
};

export const allComponentsSelector = (state: RootState) => {
    const all = state[key].records.ids.map((id: string) => {
        return state[key].records.byId[id];
    });
    return all;
};


